module.exports = __webpack_public_path__ + "img/chauffe-marcel_logo.9e7a7092.svg";